import { useCallback } from 'react';
import {
  type NodeChange ,
  type Node,
  type Edge,
  applyNodeChanges,
} from 'reactflow';

interface UseNodesChangeProps {
  nodes: Node[];
  edges: Edge[];
  setNodes: React.Dispatch<React.SetStateAction<Node[]>>;
  setEdges: React.Dispatch<React.SetStateAction<Edge[]>>;
}

export const useNodesChange = ({ nodes, edges, setNodes, setEdges }: UseNodesChangeProps) => {
  const onNodesChange = useCallback((changes: NodeChange[]) => {
    setNodes((nds) => {
      const parsedChanges = changes.reduce((res: NodeChange[], change) => {
        let validChange = true;

        if (change.type === 'remove') {
          validChange = false;
        }

        if (validChange) {
          res.push(change)
        }
        return res;
      }, []);

      return applyNodeChanges(parsedChanges, nds);
    });
  }, [edges, nodes, setNodes, setEdges]);

  return { onNodesChange };
};
